import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';

const PagoExitoso = () => {
  const { vaciarCarrito } = useCart();

  useEffect(() => {
    // 1. Limpiamos el localStorage del e-commerce
    localStorage.removeItem('cart');
    
    // 2. Ejecutamos la acción del reducer
    if (vaciarCarrito) {
      vaciarCarrito();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Círculo verde con tilde de éxito */}
        <div style={styles.iconSuccess}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
        
        <h1 style={styles.title}>¡Gracias por tu compra!</h1>
        <p style={styles.text}>
          Tu pedido fue registrado con éxito y ya lo está preparando la planta de producción.
        </p>
        
        <p style={styles.subtext}>
          Podés seguir el avance de tu orden desde la sección de{' '}
          <Link to="/pedidos" style={styles.link}>
            Seguimiento de pedidos
          </Link>.
        </p>

        <Link to="/" style={styles.btnPrimary}>
          Volver al Inicio
        </Link>
      </div>
    </div>
  );
};

// Estilos modulares rápidos en JS (los podés pasar a tu CSS)
const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '70vh', backgroundColor: '#f9fafb', padding: '20px' },
  card: { backgroundColor: '#ffffff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', textAlign: 'center', maxWidth: '500px', width: '100%' },
  iconSuccess: { width: '80px', height: '80px', backgroundColor: '#f0fdf4', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 24px' },
  iconError: { width: '80px', height: '80px', backgroundColor: '#fef2f2', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 24px' },
  iconPending: { width: '80px', height: '80px', backgroundColor: '#fef9c3', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '0 auto 24px' },
  title: { fontSize: '24px', fontWeight: 'bold', color: '#111827', marginBottom: '16px', fontFamily: 'sans-serif' },
  text: { fontSize: '16px', color: '#4b5563', marginBottom: '12px', lineHeight: '1.5', fontFamily: 'sans-serif' },
  subtext: { fontSize: '15px', color: '#6b7280', marginBottom: '28px', lineHeight: '1.5', fontFamily: 'sans-serif' },
  link: { color: '#000000', fontWeight: 'bold', textDecoration: 'underline' },
  btnPrimary: { display: 'inline-block', backgroundColor: '#000000', color: '#ffffff', padding: '12px 24px', borderRadius: '8px', textDecoration: 'none', fontWeight: '600', fontSize: '15px', transition: 'background 0.2s' }
};

export default PagoExitoso;